"use strict";

exports.__esModule = true;
exports.DeviceTableThumbnail = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Utils = require("../../../Utils");
var _Measures = require("../../Measures");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Thumbnail for DeviceTableWidget.
 */
var DeviceTableThumbnail = exports.DeviceTableThumbnail = /*#__PURE__*/function (_Component) {
  function DeviceTableThumbnail() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.renderRow = function (_ref) {
      var index = _ref.index,
        top = _ref.top,
        left = _ref.left,
        height = _ref.height;
      var _this$props = _this.props,
        children = _this$props.children,
        render = _this$props.render;
      var columnWidths = _this.getColumnWidths();
      var body = [];
      var x = left;
      for (var i = 0; i < children.length; i++) {
        var child = children[i];
        var width = columnWidths[i];
        body.push(render({
          type: child.type,
          props: Object.assign({}, child.props, {
            x: x,
            y: top,
            width: width,
            height: height
          }),
          children: child.children
        }, i));
        x += width;
      }
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
        key: index
      }, body);
    };
    return _this;
  }
  _inheritsLoose(DeviceTableThumbnail, _Component);
  var _proto = DeviceTableThumbnail.prototype;
  _proto.getColumnWidths = function getColumnWidths() {
    var _this$props2 = this.props,
      width = _this$props2.width,
      children = _this$props2.children;
    var totalFlex = 0;
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      totalFlex += getFlexValue(child);
    }
    var availableWidth = Math.floor(width - (children.length - 1));
    var flexWidth = availableWidth / totalFlex;
    return children.map(function (child) {
      return flexWidth * getFlexValue(child);
    });
  };
  _proto.render = function render() {
    var _this$props3 = this.props,
      x = _this$props3.x,
      y = _this$props3.y,
      width = _this$props3.width,
      height = _this$props3.height,
      itemHeight = _this$props3.itemHeight;
    var availableHeight = height - itemHeight;
    var totalVisible = Math.ceil(availableHeight / itemHeight);
    var visible = [];
    var top = 0;
    for (var index = 0; index < totalVisible; index++) {
      visible.push(this.renderRow({
        index: index,
        top: top,
        left: 0,
        width: width,
        height: itemHeight
      }));
      top += itemHeight;
    }
    return /*#__PURE__*/_react["default"].createElement("svg", {
      x: x,
      y: y,
      width: width,
      height: height
    }, /*#__PURE__*/_react["default"].createElement("rect", {
      x: 0,
      y: 0,
      width: width,
      height: height,
      fill: "#fff"
    }), /*#__PURE__*/_react["default"].createElement("svg", {
      width: width,
      height: itemHeight
    }, this.renderHeaders()), /*#__PURE__*/_react["default"].createElement("svg", {
      x: 0,
      y: itemHeight,
      width: width,
      height: availableHeight
    }, visible));
  };
  _proto.renderHeaders = function renderHeaders() {
    var _this$props4 = this.props,
      height = _this$props4.itemHeight,
      children = _this$props4.children;
    var columnWidths = this.getColumnWidths();
    var headers = [];
    var x = 0;
    for (var index = 0; index < children.length; index++) {
      var width = columnWidths[index];
      headers.push(/*#__PURE__*/_react["default"].createElement(_Measures.TextValue, {
        key: String(index),
        x: x,
        y: 0,
        width: width,
        height: height,
        fontSize: 24,
        value: (0, _Utils.humanizeString)(children[index].type)
      }));
      x += width;
    }
    return headers;
  };
  return DeviceTableThumbnail;
}(_react.Component);
DeviceTableThumbnail.defaultProps = {
  itemHeight: 64,
  width: 1024,
  height: 768
};
function getFlexValue(input) {
  if (typeof input.props.flex === "number") {
    return input.props.flex || 1;
  } else if (input.props.element != null && input.props.element.props != null) {
    return input.props.element.props.flex || 1;
  }
  return 1;
}